import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAddons } from '@custom/rtk-apis/Setting/addons/getAddons';

// Create the slice
const getAddonsSlice = createSlice({
  name: 'getAddons',
  initialState: {
    result: null,
    loading: false,
    error: null,
    success: false,
    status: null,
  },
  reducers: {
    resetSuccess: (state) => {
      state.success = false;
    },
    resetError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAddons.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getAddons.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.result = action.payload;
        state.success = true;
        state.status = "SUCCESS";
      })
      .addCase(getAddons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
        state.status = "FAILED";
      });
  }
});

export default getAddonsSlice.reducer;
export const { resetSuccess, resetError } = getAddonsSlice.actions;
